import { List, Stack, Typography } from '@mui/material'
import { type ReactNode } from 'react'

import GcpLogo from 'assets/logos/google-cloud-platform.svg?component'
import { AuthenticationStep } from 'components/common/mapped-entities/AuthenticationStep'
import { getGcpMetadataAuthenticationUrlFromResponse } from 'components/common/mapped-entities/gcp/authentication/gcp-integration-utils'
import { MUIExternalLinkButton } from 'components/common/MUIExternalLinkButton'
import { muiTheme } from 'mui-theme'

function GcpDeploymentButton({ templateUrl }: { templateUrl: string }) {
  return (
    <MUIExternalLinkButton
      href={getGcpMetadataAuthenticationUrlFromResponse(templateUrl)}
      startIcon={
        <GcpLogo
          aria-label="GCP Icon"
          css={{
            height: muiTheme.spacing(3),
            width: muiTheme.spacing(3)
          }}
        />
      }
    >
      Deploy to GCP
    </MUIExternalLinkButton>
  )
}

/**
 * children will likely be a form context wrapping the necessary auth fields in a form controller
 */
export function GcpAuthenticationSection({
  children,
  templateUrl
}: {
  children: ReactNode
  templateUrl: string
}) {
  return (
    <Stack sx={{ rowGap: 3, width: '100%' }}>
      <List disablePadding>
        <AuthenticationStep
          badgeNumber={1}
          title="Do you have the correct role and permissions?"
        >
          <Typography>
            {/* TODO: replace copy */}
            <b>Placeholder</b>
          </Typography>
        </AuthenticationStep>
        <AuthenticationStep
          badgeNumber={2}
          /* TODO: replace copy */
          title="Launch {tbd}"
        >
          <Typography>
            {/* TODO: replace copy */}
            <b>Placeholder</b>
          </Typography>
          <GcpDeploymentButton templateUrl={templateUrl} />
        </AuthenticationStep>
        <AuthenticationStep
          badgeNumber={3}
          /* TODO: replace copy */
          title="Paste {tbd}"
        >
          <Typography>
            {/* TODO: replace copy */}
            <b>Placeholder</b>
          </Typography>
          {children}
        </AuthenticationStep>
      </List>
    </Stack>
  )
}
